import React from 'react';

const MonumentIcon = (props) => {
  return (
    <img
      alt="Pomnik"
      src="/static/images/icons/tourist_attractions/monument.svg"
      {...props}
    />
  );
};

export default MonumentIcon;
